import { AxiosInstance } from 'axios';

export class S3Repository {
  constructor(private axiosInstance: AxiosInstance) {}
  async uploadFileToStorage(file: File, presignedUrl: string): Promise<void> {
    return await this.axiosInstance.put(presignedUrl, file, { headers: { 'Content-Type': file.type } });
  }
}
